import { render, staticRenderFns } from "./customerPage.vue?vue&type=template&id=4f6ddb12&"
import script from "./customerPage.vue.ts?vue&type=script&lang=ts&"
export * from "./customerPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports